export default __webpack_public_path__ + "static/media/switch.d8ceb19a.svg";